import React from 'react';
import { Box, InputAdornment } from '@mui/material';
import { FormProvider } from 'react-hook-form';
import { RHFTextField } from '../RHF';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import CustomDialog from '../Dialog/Dialog';
import { CustomButton } from 'components/Button';
import logoImage from '../../assets/images/logo.svg';
import userImage from '../../assets/images/user.svg';
import emailImage from '../../assets/images/email.svg';

interface DemoRequestFormProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: DemoRequestFormData) => void;
  isPending: boolean;
  isRetrying?: boolean;
}

interface DemoRequestFormData {
  customer_name: string;
  customer_email: string;
}

const validationSchema = yup.object({
  customer_name: yup.string().required('Name is required'),
  customer_email: yup.string().email('Invalid email').required('Email is required'),
});

const DemoRequestForm: React.FC<DemoRequestFormProps> = ({
  open,
  onClose,
  onSubmit,
  isPending,
  isRetrying = false,
}) => {
  const formMethods = useForm<DemoRequestFormData>({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      customer_name: '',
      customer_email: '',
    },
  });

  const handleSubmit = (data: DemoRequestFormData) => {
    onSubmit(data);
  };

  return (
    <CustomDialog
      open={open}
      handleClose={onClose}
      isHeader={false}
      width="486px"
      fullWidth={true}
    >
      <FormProvider {...formMethods}>
        <form onSubmit={formMethods.handleSubmit(handleSubmit)}>
          <Box className={"auth-form-container"}>
            <img src={logoImage} alt="logo" className="auth-form-logo d-block" />

            <p className="divider" />

            <p className="auth-form-title">Request a Demo</p>
            <p className="auth-form-text">
              Get a free demo link sent to your inbox. We'll show you how LottoReco can help your store reconcile lottery sales in under 5 minutes.
            </p>

            <Box className={"textfieldCont"}>
              <RHFTextField
                name="customer_name"
                placeholder="Your Name"
                slotProps={{
                  input: {
                    startAdornment: <InputAdornment position="start"><img src={userImage} alt="user" /></InputAdornment>,
                  },
                }}
              />
            </Box>

            <Box className={"textfieldCont"}>
              <RHFTextField
                name="customer_email"
                placeholder="Email Address"
                type="email"
                slotProps={{
                  input: {
                    startAdornment: <InputAdornment position="start"><img src={emailImage} alt="email" /></InputAdornment>,
                  },
                }}
              />
            </Box>

            <Box>
              <CustomButton
                type="submit"
                loading={isPending}
                disabled={isPending}
                className="button-base button-compact auth-form-button"
              >
                {isRetrying ? 'Retrying...' : isPending ? 'Sending...' : 'Get Demo Link'}
              </CustomButton>
            </Box>
          </Box>
        </form>
      </FormProvider>
    </CustomDialog>
  );
};

export default DemoRequestForm;
